import React, { useState } from "react";
import Swal from "sweetalert2";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [sending, setSending] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(
        "https://admin.businessunbuzzed.com/api/user/login?",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );
      const data = await res.json();
      if (data.token) {
        localStorage.setItem("token", data.token);
        window.location.href = "/";
      } else {
        let errorMsg = "Unknown error";
        if (data.errors) {
          errorMsg = Object.values(data.errors).flat().join(", ");
        } else if (data.message) {
          errorMsg = data.message;
        }
        Swal.fire({
          icon: "error",
          title: "❌ Login Failed",
          text: errorMsg,
          confirmButtonColor: "rgb(204, 102, 0)",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "⚠️ Something went wrong!",
        text: "Please try again later",
        confirmButtonColor: "rgb(204, 102, 0)",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!forgotEmail) {
      return Swal.fire({
        icon: "warning",
        title: "⚠️ Missing Email",
        text: "Please enter your email",
        confirmButtonColor: "rgb(204, 102, 0)",
      });
    }
    setSending(true);
    try {
      const res = await fetch(
        "https://admin.businessunbuzzed.com/api/forgot-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ email: forgotEmail }),
        }
      );
      const data = await res.json();
      if (data.message) {
        Swal.fire({
          icon: "success",
          title: "✅ Success",
          text: data.message,
          confirmButtonColor: "rgb(204, 102, 0)",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "❌ Failed",
          text: "Could not send reset link",
          confirmButtonColor: "rgb(204, 102, 0)",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "⚠️ Something went wrong!",
        text: "Please try again later",
        confirmButtonColor: "rgb(204, 102, 0)",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-left">
          <h2 className="auth-title">Welcome Back 👋</h2>
          <p className="auth-subtitle">Please login to your account</p>

          {!showForgot ? (
            <form className="auth-form" onSubmit={handleLogin}>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <button
                type="button"
                className="btn-link margin-b"
                onClick={() => setShowForgot(true)}
              >
                Forgot Password?
              </button>

              <button type="submit" className="btn-custom" disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </button>
            </form>
          ) : (
            <form className="auth-form" onSubmit={handleForgotPassword}>
              <h3>Forgot Password</h3>
              <p>Enter your email to receive a password reset link</p>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn-custom" disabled={sending}>
                {sending ? "Sending..." : "Send Reset Link"}
              </button>
              <button
                type="button"
                className="btn-link"
                onClick={() => setShowForgot(false)}
              >
                Back to Login
              </button>
            </form>
          )}

          <p className="auth-text">
            Don’t have an account? <a href="/signup">Sign Up</a>
          </p>
        </div>

        <div className="auth-right">
          <img
            src="/img/international-business.png"
            alt="Login"
            className="auth-image"
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
